import React from 'react';
import styled from 'styled-components';
import { baseCardCSS } from '../../theme'; // <-- Import the CSS string from theme.js

// --- STYLES ARE NOW DEFINED LOCALLY IN THIS FILE ---

const CardContainer = styled.div`
  ${baseCardCSS} // <-- Use the imported CSS string
  cursor: pointer;
`;

const UserCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const UserName = styled.h3`
  color: ${({ theme }) => theme.heading};
  margin: 0;
  font-size: 18px;
`;

const UserRole = styled.span`
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  padding: 4px 8px;
  border-radius: 6px;
  color: white;
  background-color: ${props => 
    props.role === 'admin' ? '#0a84ff' : 
    props.role === 'data-entry' ? '#ff9500' : '#3a3a3c'};
`;

const UserEmail = styled.p`
  color: ${({ theme }) => theme.text};
  font-size: 14px;
  margin: 0 0 15px 0;
`;

const StatRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  margin-bottom: 8px;
`;

const StatLabel = styled.span`
  color: ${({ theme }) => theme.text};
`;

const StatValue = styled.span`
  color: ${({ theme }) => theme.heading};
  font-weight: 600;
  background-color: ${({ theme }) => theme.navActiveBg};
  padding: 2px 8px;
  border-radius: 6px;
`;

// --- COMPONENT LOGIC ---

const UserCard = ({ user, onClick }) => {
  return (
    <CardContainer onClick={onClick}>
      <UserCardHeader>
        <UserName>{user.clientName || user.email}</UserName>
        <UserRole role={user.role}>{user.role}</UserRole>
      </UserCardHeader>
      <UserEmail>{user.email}</UserEmail>
      <StatRow>
        <StatLabel>Total Documents</StatLabel>
        <StatValue>{user.docCount || 0}</StatValue>
      </StatRow>
    </CardContainer>
  );
};

export default UserCard;